import { FormControl, FormGroup, Validators, FormArray } from "@angular/forms";

export interface rbac {
  mgr: string[],
  vsl: string[],
  rids: number[],
}

export interface getTenantData {
  id: string,
  name: string,
  description: string,
  status_id: number,
  rbac: rbac[],
  expiration_date: string,
}

export interface postTenantData {
  id: string,
  name: string,
  description: string,
  status_id: number,
  rbac: rbac[],
  expiration_date: string | undefined,
}

export class tenantForm {
  defaultForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    description: new FormControl(''),
    status_id: new FormControl(1),
    rbac: new FormControl<rbac[]>([]),
    expiration_date: new FormControl(''),
  })
}

